import type { ReactNode } from 'react'

import * as styles from './form-group.styles'

type Props = {
  className?: string
  row?: boolean
  children: ReactNode
}

export const FormGroup = ({ children, className, row = false }: Props) => {
  const css = [styles.root, row && styles.row]

  return (
    <div className={className} css={css} data-testid="form-group">
      {children}
    </div>
  )
}
